import React, { useEffect, useRef } from "react";
import ReactTable from "react-table";

import { makeStyles } from "@material-ui/core/styles";
import History from "@material-ui/icons/History";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import { bookingApi } from "functions/apis";

const styles = {
  cardIconTitle: { ...cardTitle, marginTop: "15px", marginBottom: "0px" }
};
const useStyles = makeStyles(styles);

export default function GenerationRunList() {
  const source = useRef(new AbortController());

  const [data, setData] = React.useState([]);
  const [pages, setPages] = React.useState(0);
  const [pagination, setPagination] = React.useState({
    pageIndex: 1,
    pageSize: 10
  });
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    return () => source.current.abort();
  }, []);

  useEffect(() => {
    setLoading(true);
    bookingApi
      .get("/AgentQuotaGenerationRuns", {
        signal: source.current.signal,
        params: { filter: { sort: 1 }, pagination }
      })
      .then(data => {
        setData(
          data.records.map(record => ({
            ...record,
            agentCode: record.agent?.code,
            fromLabel: record.fromDate?.substring(0, 10),
            targetLabel: record.targetDate?.substring(0, 10),
            completedAtLabel: record.completedAt
              ?.replace("T", " ")
              .substring(0, 19)
          }))
        );
        setPages(Math.ceil(data.totalRecords / pagination.pageSize));
        setLoading(false);
      })
      .catch(error => console.log(error));
  }, [pagination]);

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <History />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>QUOTA GENERATION RUNS</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              manual
              pages={pages}
              page={pagination.pageIndex - 1}
              pageSize={pagination.pageSize}
              onPageChange={page =>
                setPagination({ ...pagination, pageIndex: page + 1 })
              }
              onPageSizeChange={(pageSize, page) =>
                setPagination({ pageSize, pageIndex: page + 1 })
              }
              loading={loading}
              data={data}
              filterable={false}
              columns={[
                { Header: "Completed", accessor: "completedAtLabel" },
                { Header: "Agent", accessor: "agentCode" },
                { Header: "From", accessor: "fromLabel" },
                { Header: "Target Date", accessor: "targetLabel" },
                { Header: "Created Rows", accessor: "createdRows" }
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              className="-striped -highlight"
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
